<template>
	<div class="container-fluid bg-white">
		<toolbar>
			<h2><i class="fa fa-project-diagram"></i> Contacts Network</h2>
			
			<div class="controls">
				<template v-if="$store.windowWidth > 850">
					<router-link to="/contact/new/details" class="btn btn-light">
						<i class="fa fa-address-book fa-fw"></i>
						<i class="fa fa-plus fa-fw"></i>
						New Contacts Entry...
					</router-link>

					<button class="btn btn-light" v-on:click="inviteForm.visible = true" :disabled="inviteForm.visible">
						<i class="fa fa-paper-plane fa-fw"></i>
						Invite to {{$store.appName}}...
					</button>
				</template>

				<nav-tabs :tabs="[
						{
							icon: 'fa-project-diagram',
							label: 'Contacts',
							path: '/contacts'
						},
						{
							icon: 'fa-tractor',
							label: 'All Assets',
							path: '/contact-assets'
						}
					]">
				</nav-tabs>

				<context-menu
					:menu-items="contextMenuItems"
					v-on:exportToCSV="exportToCSV"
					v-on:openInviteForm="inviteForm.visible = true"
					v-on:openOperationsModal="operationsModal.visible = true"
					v-on:newContactsEntry="$router.push('/contact/new/details')">
				</context-menu>
			</div>
		</toolbar>

		<div v-if="!inviteForm.visible" class="d-flex align-items-center flex-wrap">
			<search-bar class="flex-grow-1 mr-2"
				placeholder="Search Contacts..."
				full-width="true" 
				v-on:submit="searchContacts" 
				v-on:clearSearch="searchContacts">		
			</search-bar>

			<label class="mb-0">
				<input type="checkbox" v-model="searchTradetraks">
				Include all of {{$store.appName}}
			</label>
		</div>

		<alert :visible="inviteForm.visible" v-on:close="inviteForm.visible = false" class="alert-info">
			<form v-on:submit.prevent="sendInvite">
					
				<field label="Email Address" 
					col-class="stacked" 
					v-model="inviteForm.email">
				</field>

				<div>
					<label v-on:click="inviteForm.joinCompany = true" v-on:change="inviteToggle" class="col-form-label">
						<input type="checkbox" v-model="inviteForm.joinCompany" value="1">
						Invite to {{$store.company.company_name}}
					</label>
				</div>
				
				<field label="Message" 
					col-class="stacked" 
					:params="{type:'textarea'}" 
					v-model="inviteForm.message"
					v-on:change="messageChanged">
				</field>

				<div class="float-right">
					<button type="button" class="btn btn-light" v-on:click="inviteForm.visible = false">
						Cancel
					</button>
					<button type="submit" class="btn btn-primary">
						<i class="fa fa-paper-plane"></i>
						Send
					</button>
				</div>
				<div style="clear: both;"></div>

			</form>
		</alert>

		<table-list
			:loading="loading"
			:records="mutatedContacts"
			:fields="fields"
			:mobile-breakpoint="$store.tableListMobileBreakpoint"
			:total-paginated-records="numResults"
			:hide-record-count="$store.tableListMobileBreakpoint > $store.windowWidth"
			record-name="Contact"
			edit-button-text=" "
			edit-button-icon="fa-link"
			:has-edit="true"
			v-on:edit="openContact"
			:sortable="true"
			:no-header="true"
			:clickable-row="true"
			id-field="slug">

			<div class="d-flex flex-wrap align-items-center mr-4">
				<field v-model="typeFilter" 
					v-on:change="fetchData" :params="{
					type:'btn-group',
					buttons:[
						{value: 'all',text:'All'},
						{value: 'companies',text:'Companies'},
						{value: 'individuals',text:'Individuals'}
					],
					tabStyling:true}"
					class="mr-2">
				</field>

				<field v-model="supplierCustomerFilter" v-on:change="fetchData" :params="{
					type:'btn-group',
					buttons:[
						{value: 'all',text:'All'},
						{value: 'customers',text:'Customers'},
						{value: 'suppliers',text:'Suppliers'}
					],
					tabStyling:true}"
					class="mr-2">
				</field>

				<template v-if="qboIsActive && hasModulePermWrite('Contacts')">
					<button 
						v-on:click="importQBOEntities('customers')" 
						class="btn btn-light mr-2" 
						:disabled="importing">

						<i class="fa" :class="importing ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
						Import Customers from QBO
					</button>
					<button 
						v-on:click="importQBOEntities('vendors')" 
						class="btn btn-light mr-2" 
						:disabled="importing">

						<i class="fa" :class="importing ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
						Import Vendors from QBO
					</button>
				</template>
			</div>

		</table-list>

		<pagination 
			:pages="numPages" 
			:current-page="page"
			v-on:pageChange="changePage">
		</pagination>

		<modal-dialog :modal-visible="importConfirmModal.visible"
			:title="'Import '+importConfirmModal.type+' from Quickbooks'"
			confirm-button-text="Proceed with Import"
			:working="importing"
			v-on:confirm="proceedWithImport"
			v-on:closeModal="importConfirmModal.visible = false">

			<div v-if="!importing">
				<p>There are {{importConfirmModal.importCount}} records from Quickbooks to import.</p>

				<p v-if="importConfirmModal.importCount > 500"><strong>It may take several minutes to complete this import.</strong> Once you start the import, you can navigated away come back later.</p>
			</div>
			<div v-else class="text-center">
				<spinner :inline="true"></spinner>
				<p>Import in progress. This may take some time. You may navigate away and come back later.</p>
			</div>
		</modal-dialog>

		<modal-dialog :modal-visible="operationsModal.visible"
			title="Contact Operations"
			:submit-visible="false"
			cancel-button-text="Done"
			v-on:closeModal="operationsModal.visible = false">

			<accordion heading="Toggle Invoice Attachments">

				<p>Clicking one of these buttons will batch-update the "Attach documents directly to email as PDF" toggle in every customer's invoice settings. Documents sent as attached PDFs will lose all open/read tracking capability.</p>

				<div class="d-flex">
					<button class="btn btn-primary" v-on:click="toggleAttachedPdfs(false)">
						Deliver via notice email/portal
					</button>
					<button class="btn btn-light" v-on:click="toggleAttachedPdfs(true)">
						Attach as PDFs
					</button>
				</div>

			</accordion>

		</modal-dialog>

		<modal-dialog :modal-visible="confirmModal.visible"
			title="Confirm?"
			confirm-button-text="Yes, Proceed"
			:working="confirmModal.working"
			v-on:confirm="actionConfirmed"
			v-on:closeModal="confirmModal.visible = false">

			{{ confirmModal.message }}

		</modal-dialog>

	</div>
</template>

<script>
import Toolbar from "../layout_fragments/Toolbar"
import TableList from "../components/TableList"
import Field from "../components/Field"
import SearchBar from "../components/SearchBar"
import Pagination from "@/components/Pagination"
import Alert from "@/components/Alert"
import ModalDialog from "@/components/ModalDialog"
import ContextMenu from "@/layout_fragments/ContextMenu"
import Spinner from "@/components/Spinner"
import Accordion from "@/components/Accordion"
import NavTabs from "@/layout_fragments/NavTabs"

export default {

	name: 'Customers',
	components: {
		Toolbar,
		TableList,
		Field,
		SearchBar,
		Pagination,
		Alert,
		ContextMenu,
		ModalDialog,
		Spinner,
		Accordion,
		NavTabs
	},
	data() {
		return {
			showSearch: true,
			typeFilter: "all",
			supplierCustomerFilter: 'all',
			searchTradetraks: false,
			contacts: [],
			importConfirmModal: {
				visible: false,
				importCount: 0,
				working: false,
				type: null
			},
			inviteForm: {
				visible: false,
				email: "",
				message: "Hi, we'd like you to join our company on "+this.$store.appNameProper,
				joinCompany: true,
				messageEdited: false
			},
			operationsModal: {
				visible: false
			},
			confirmModal: {
				visible: false,
				confirmActionFunction: false,
				message: "",
				working: false
			},
			fields: [
				{
					key: "image",
					showOnMobile: false
				},
				{
					key: "main"
				},
				{
					key: "contactDetails",
					showOnMobile: false
				},
				{
					key: "typeDetails",
					showOnMobile: false
				},
				{
					key: "resultType"
				}
			],
			buttons: [
				{
					class: "btn-light",
					text: "Edit Details",
					link: "/project/{?}",
					icon: "fa-pencil-alt",
				}
			],
			loading: true,
			importing: false,
			page: 1,
			numPages: 0,
			numResults: 0
		}
	},
	computed: {
		buttonsFilteredForPerms() {
			return this.filterNavForPerms(this.buttons)
		},
		contextMenuItems() {
			let items = [
				{
					icon: 'fa-download',
					text: 'Export to CSV',
					clickFunction: 'exportToCSV'
				},
				{
					icon: 'fa-cog',
					text: 'Operations...',
					clickFunction: 'openOperationsModal'
				}
			]

			if (this.$store.windowWidth <= 850) {

				let buttons = [
					{
						icon: 'fa-plus',
						text: 'New Contacts Entry',
						clickFunction: 'newContactsEntry'
					},
					{
						icon: 'fa-paper-plane',
						text: 'Invite to '+this.$store.appName,
						clickFunction: 'openInviteForm'
					}
				]

				items = [
					...buttons,
					...items
				]
			}

			return items
		},
		mutatedContacts() {
			let vm = this

			return this.contacts.map(contact => {
				let image = "", mainTitle = "", subTitleString = "", linkedEmail = "", linkedPhone = "", contactType = "", contactOwner = "", companyOrIndividualOrTitle = ""

				linkedPhone = "<a href='tel:"+contact.phone+"'>"+contact.phone+"</a>";

				if (contact.email)
					linkedEmail = "<a href='mailto:"+contact.email+"'>"+contact.email+"</a>"

				if (contact.resultType == "Contacts Entry") {
					image = "<i class='fa fa-address-book fa-2x'></i>"

					mainTitle = contact.name

					companyOrIndividualOrTitle = contact.is_company == 1 ? 'Company' : 'Individual'

					if (contact.is_customer == 1)
						contactType = "Customer"
					else if (contact.is_supplier == 1)
						contactType += " Supplier"

					subTitleString = vm.createAddressString(contact)

					if (contact.contact_id > 0 && contact.Company) {
						contactOwner = " at "+contact.Company.name

						if (contact.position)
							companyOrIndividualOrTitle = contact.position
					}
				}
				else if (contact.resultType == "User Account") {
					mainTitle = contact.first_name+" "+contact.last_name
					subTitleString = contact.description

					if (!contact.phone)
						linkedPhone = "<a href='tel:"+contact.phone_mobile+"'>"+contact.phone_mobile+"</a>";

					if ("ProfileImage" in contact && contact.ProfileImage) 
						image = "<img style='width:80px' src='"+window.apiRoot+"/resources/profile-images/"+contact.ProfileImage.slug+"/"+contact.ProfileImage.filename+"'>"
					else
						image = "<i class='fa fa-user fa-2x'></i>"

				}
				else if (contact.resultType == "Company Account") {
					mainTitle = contact.company_name

					subTitleString = vm.createAddressString(contact)

					if ("BusinessType" in contact && contact.BusinessType)
						companyOrIndividualOrTitle = "<span class='text-muted'>Works in "+contact.BusinessType.map(type => type.type).join(", ")+"</span>"

					if ("ProfileImage" in contact && contact.ProfileImage) 
						image = "<img style='width:80px' src='"+window.apiRoot+"/resources/profile-images/"+contact.ProfileImage.slug+"/"+contact.ProfileImage.filename+"'>"

				}

				contact.image = image
				contact.main = "<div><strong>"+mainTitle+"</strong></div>"
				
				if (subTitleString)
					contact.main += "<div class='text-muted'>"+subTitleString+"</div>"

				contact.contactDetails = linkedEmail+"<br>"+linkedPhone
				contact.typeDetails = "<div>"+companyOrIndividualOrTitle+"</div><div class='text-muted'>"+contactType+contactOwner+"</div>"

				return contact
			})
		}
	},
	methods: {
		createAddressString(contact) {
			let addressString = ""

			if (contact.suite)
				addressString = contact.suite+" "

			if (contact.address)
				addressString += contact.address+"<br>"

			if (contact.city)
				addressString += contact.city
			if (contact.province)
				addressString += ", "+contact.province
			if (contact.country)
				addressString += ", "+contact.country
			if (contact.postal_code)
				addressString += " "+contact.postal_code

			return addressString
		},
		messageChanged() {
			this.inviteForm.messageEdited = true
		},
		inviteToggle() {
			if (!this.inviteForm.messageEdited) {
				if (this.inviteForm.joinCompany) 
					this.inviteForm.message = "Hi, we'd like you to join our company on "+this.$store.appNameProper
				
				else 
					this.inviteForm.message = "Hi, we'd like you to join "+this.$store.appNameProper+"!"
				
			}
		},
		importQBOEntities(type) {
			let vm = this

			this.spinner(true)
			this.importing = true
			this.importConfirmModal.visible = true
			this.importConfirmModal.type = type

			this.postData("QuickbooksConnection/import-"+type,{checkCount:true}).then(response => {
				vm.spinner(false)
				vm.importing = false

				if (response.success) 
					vm.importConfirmModal.importCount = response.data.importCount
			});
		},
		proceedWithImport() {
			let vm = this

			this.spinner(true)
			this.importing = true
			this.importConfirmModal.working = true

			this.postData("QuickbooksConnection/import-"+this.importConfirmModal.type).then(response => {
				vm.spinner(false)
				vm.importing = false
				vm.importConfirmModal.working = true

				if (response.success) {
					vm.alertSuccess(response.data.imported_count+" "+vm.importConfirmModal.type+" imported from Quickbooks Online!")
					vm.importConfirmModal.visible = false
					vm.fetchData()
				}
			});
		},
		openContact(record) {
			if (record.resultType == "Contacts Entry")
				this.$router.push("/contact/"+record.slug+"/summary")
			else if (record.resultType == "User Account") 
				this.$router.push("/profile/user/"+record.slug)
			else if (record.resultType == "Company Account")
				this.$router.push("/profile/company/"+record.slug)
		},
		sendInvite() {
			let vm = this

			let payload = {
				email: vm.inviteForm.email,
				message: vm.inviteForm.message,
				joinCompany: vm.inviteForm.joinCompany
			}

			this.postData("User/invite",payload,true).then(response => {
				if (response.success) {
					vm.inviteForm.email = ""
					vm.inviteForm.message = ""
					vm.alertSuccess("Invite sent!")
				}
			})
		},
		searchContacts(terms) {
			let vm = this

			terms = encodeURIComponent(terms)

			let filters = [
				["name",terms,"and","like"],
				["address",terms,"or","like"],
				["city",terms,"or","like"],
				["email",terms,"or","like"]
			]

			vm.spinner(true)
			vm.loading = true

			let params = {
				filters,
				include: [{model: "Contact",fields:["id","slug","name"]}],
				useLinkedData: true
			}

			this.typeFilter = "all"

			let promises = [
				this.getJSON("Contact/get",params)
			]

			if (this.searchTradetraks) {

				let include = ["ProfileImage",{model:"CompanyUser",include:["Company"]}];

				let filters = []

				//if terms are separate by a space, assume first and last name
				if (terms.indexOf(" ") >= 0) {
					let names = terms.split(" ")

					filters = [
						['first_name',names[0],"and","like"],
						['last_name',names[names.length-1],"and","like"]
					]
				}
				else {
					filters = [
						["first_name",terms,"and","like"],
						["last_name",terms,"or","like"],
						["address",terms,"or","like"],
						["city",terms,"or","like"],
						["phone",terms,"or","like"],
						["email",terms,"or"] //email must be exact match to prevent getting full company roster based on @company.com search
					]
				}

				let payload = {
					include: include,
					filters: filters
				}

				if (this.includeInactive)
					payload.includeFormer = true

				let endpoint = "get"
				if (this.searchScope == 'all') {
					endpoint = "public-search"
					payload.terms = terms
					delete payload.filters
				}
				else {
					payload.includeFormer = true
					payload.includeUnconnected = true
					//payload.filters.push(["CompanyUser.invite_accepted !=",null])
					//payload.filters.push(["CompanyUser.is_inactive",0])
				}

				endpoint = "public-search"

				payload = {
					terms: terms,
				}

				if (this.searchTradetraks)
					payload.includeAll = true

				promises.push(vm.getJSON("User/"+endpoint,payload,true))

				payload = {
					filters: [["company_name",terms,"and","like"]],
					include: ['ProfileImage','BusinessType']
				}

				promises.push(vm.getJSON("Company/get",payload,true))
			}

			Promise.all(promises).then(responses => {
				vm.spinner(false)
				vm.loading = false

				if (responses[0].success) {
					vm.contacts = responses[0].data.map(contact => {
						contact.resultType = "Contacts Entry"
						return contact
					})
					vm.numPages = 0
					vm.numResults = responses[0].meta.num_results
				}
				if (responses.length > 1 && responses[1].success) {
					vm.contacts = vm.contacts.concat(responses[1].data.map(contact => {
						contact.resultType = "User Account"
						return contact
					}))
					vm.numResults += responses[1].data.length
				}
				if (responses.length > 2 && responses[2].success) {
					vm.contacts = vm.contacts.concat(responses[2].data.map(contact => {
						contact.resultType = "Company Account"
						return contact
					}))	
					vm.numResults += responses[2].data.length
				}
			})
		},
		changePage(page) {
			this.page = page
			this.fetchData()
		},
		exportToCSV() {
			let vm = this

			let params = {
				fields: [
					"name",
					"suite",
					"address",
					"city",
					"province",
					"postal_code",
					"phone",
					"email",
					"website",
				],
				format: "csv"
			}

			//this.getJSON("Contact/get",params)

			window.location = window.apiBase+"Contact/get?fields="+JSON.stringify(params.fields)+"&format=csv&token="+this.$store.sessionToken+"&humanReadable=true"
		},
		actionConfirmed() {
			this[this.confirmModal.confirmActionFunction]()
			this.confirmModal.working = true
		},
		toggleAttachedPdfs(usePdf) {
			this.confirmModal.visible = true

			if (usePdf) {
				this.confirmModal.message = "Are you sure you want to toggle all contacts to send documents via attached PDFs? This operation will over-write your current settings and cannot be undone. This operation may take several seconds if you have a large Contact database."
				this.confirmModal.confirmActionFunction = "confirmToggleOnAttachedPdfs"
			} 
			else {
				this.confirmModal.message = "Are you sure you want to toggle all contacts to send documents via an email notice to the portal? This operation will over-write your current settings and cannot be undone. This operation may take several seconds if you have a large Contact database."
				this.confirmModal.confirmActionFunction = "confirmToggleOffAttachedPdfs"
			}
		},
		confirmToggleOnAttachedPdfs() {
			this.confirmToggleAttachedPdfs(true)
		},
		confirmToggleOffAttachedPdfs() {
			this.confirmToggleAttachedPdfs(false)
		},
		confirmToggleAttachedPdfs(usePdf) {
			let vm = this

			let params = {
				filters: [
					['is_customer',1]
				],
				fields: [
					"id",
					"slug",
					"settings_json"
				]
			}

			this.getJSON("Contact/get",params).then(response => {
				if (response.success) {
					let customers = response.data

					let batchPayload = []

					customers.forEach(customer => {
						let settings = false
						try {
							settings = JSON.parse(customer.settings_json)
						}
						catch (e) {
							settings = {}
						}

						if (!settings) 
							settings = {}
						
						if (usePdf)
							settings.attachDirectly = 1
						else
							settings.attachDirectly = 0
						
						batchPayload.push({
							slug: customer.slug,
							settings_json: JSON.stringify(settings)
						})
					})

					//split into 1000 count batches
					let chunkSize = 1000
					let chunkedPayloads = []
					for (let i = 0; i < batchPayload.length; i += chunkSize) {
						const chunk = batchPayload.slice(i, i + chunkSize);
						chunkedPayloads.push(chunk)
					}

					let promises = []
					chunkedPayloads.forEach(payload => {
						promises.push(vm.postData("Contact/save-batch",{records: JSON.stringify(payload)}))
					})

					Promise.all(promises).then(responses => {
						let totalRecordsSaved = responses.reduce((acc,response) => acc + +response.data.records_saved,0)

						vm.alertSuccess("Operation completed successfully on " + totalRecordsSaved + " customers")
						vm.confirmModal.working = false
						vm.confirmModal.visible = false
					})
					
				}
			})
		},
		fetchData() {
			let vm = this

			let filters = []

			if (this.typeFilter == 'companies')
				filters.push(["is_company",1])
			else if (this.typeFilter == 'individuals')
				filters.push(["is_company",0])

			if (this.supplierCustomerFilter == 'customers')
				filters.push(["is_customer",1])
			else if (this.supplierCustomerFilter == "suppliers")
				filters.push(["is_supplier",1])

			let params = {
				filters: filters,
				page: this.page,
				include: [{model: "Contact",fields:["id","slug","name"]}],
				useLinkedData: true
			}

			let promises = [
				this.getJSON("Contact/get",params,true)
			]

			this.spinner(true)
			vm.loading = true

			Promise.all(promises).then(function(responses){
				vm.spinner(false)
				vm.loading = false

				if (responses[0].success) {
					vm.contacts = responses[0].data.map(contact => {
						contact.resultType = "Contacts Entry"
						return contact
					})
					vm.numPages = responses[0].meta.num_pages
					vm.numResults = responses[0].meta.num_results
				}
			})
		}
	},
	created() {
		this.fetchData()
		this.spinner(true)

	}

}
</script>
